<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>Splits
          <v-tooltip right>
            <v-icon slot="activator" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            <span>How would you like to split your campaign?</span>
          </v-tooltip>
        </h1>
      </v-flex>

      <v-flex xs6>
          <v-card
            class="mx-auto"
            color="white"
            max-width="400"
          >
            <v-toolbar
              text
              color="transparent"
            >

              <v-toolbar-title>Audience split</v-toolbar-title>
              <div class="flex-grow-1"></div>

            </v-toolbar>

            <v-container class="py-0">
              <v-row
                align="center"
                justify="start"
              >
                <v-col
                  v-for="(selection, i) in selections"
                  :key="selection.text"
                  class="shrink"
                >
                  <v-chip
                    :disabled="loading"
                    close
                    @click:close="selected.splice(i, 1)"
                  >
                    <v-icon
                      left
                      v-text="selection.icon"
                    ></v-icon>
                    {{ selection.text }}
                  </v-chip>
                </v-col>

              </v-row>
            </v-container>

            <v-divider v-if="!allSelected"></v-divider>

            <v-list>
              <template v-for="(item, i) in categories">
                <v-list-item
                  v-if="!selected.includes(i)"
                  :key="i"
                  :disabled="loading"
                  @click="selected.push(i)"
                >
                  <v-list-item-avatar>
                    <v-icon
                      :disabled="loading"
                      v-text="item.icon"
                    ></v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-card>

        </v-flex>
        <v-flex xs4>

          <v-card
              class="mx-auto"
              min-width="300"
              max-width="300"
              tile
            >
                    <v-toolbar
                text
                color="transparent"
              >

                <v-toolbar-title>Geographic split</v-toolbar-title>
                <div class="flex-grow-1"></div>

              </v-toolbar>
              <v-list rounded>
                <v-list-item-group v-model="selectedItem" color="primary">
                  <v-list-item
                    v-for="(item, i) in geos"
                    :key="i"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
      </v-flex>

    </v-layout>
    <v-layout class="mt-3" row justify-space-between>
        <v-btn
          v-if="showButtons"
          @click="previousPage"
        >Previous</v-btn>
        <v-btn
          v-if="showButtons"
          color="primary"
          :disabled="!next"
          @click="nextPage"
        >
          Next
        </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import AudiencePathSelector from './AudiencePathSelector.vue'
import RecommendedAudiencesTable from './RecommendedAudiencesTable.vue'
import SavedAudiencesTable from './SavedAudiencesTable.vue'
import UploadStepper from './upload-stepper/Index'
import VoterList from './voter-list/Index'
import FbAudience from './fb-audience/Index'
import Rem from './rem/Index'
import Lookalike from './lookalike/Index'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'audience',
  components: {
    AudiencePathSelector,
    RecommendedAudiencesTable,
    SavedAudiencesTable,
    UploadStepper,
    VoterList,
    FbAudience,
    Rem,
    Lookalike
  },
  data () {
    return {
      dialog: false,
      filesTableActive: false,
      next: true,
      activeComponent: 'saved-audiences-table',
      items: [
          {
            text: 'Likely party',
            icon: 'assignment_ind'
          },
          {
            text: 'Turnout score',
            icon: 'directions_walk'
          },
          {
            text: 'Candidate support',
            icon: 'sentiment_satisfied_alt'
          },
          {
            text: 'Issue support',
            icon: 'local_florist'
          },
          {
            text: 'Life stage',
            icon: 'school'
          }
    ],
    loading: false,
    search: '',
    selected: [],
    selectedItem: 1,
    geos: [
        { text: 'Zip code' },
        { text: 'City' },
        { text: 'County' },
        { text: 'State House District' },
        { text: 'State Senate District' },
        { text: 'Congressional District' },
        { text: 'State' }
      ]
    }
  },
  props: {
    campaign: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      files: 'getAudiences'
    }),
    showButtons () {
      const forbidenPaths = ['voter-list']
      if (forbidenPaths.find(p => p === this.activeComponent)) return false
      return true
  },
  allSelected () {
      return this.selected.length === this.items.length
    },
    categories () {
      const search = this.search.toLowerCase()

      if (!search) return this.items

      return this.items.filter(item => {
        const text = item.text.toLowerCase()

        return text.indexOf(search) > -1
      })
    },
    selections () {
      const selections = []

      for (const selection of this.selected) {
        selections.push(this.items[selection])
      }

      return selections
    }
  },
  watch: {
    selected () {
      this.search = ''
    }
  },
  methods: {
    setCampaignProperty (property, value) {
      this.$emit('setCampaignProperty', property, value)
    },
    closeDialog () {
      this.activeComponent = 'saved-audiences-table'
    },
    showAudiencesTable () {
      this.activeComponent = 'saved-audiences-table'
    },
    selectCreativePath (path) {
      this.activeComponent = path
    },
    addFile (file) {
      this.filesTableActive = true
      Object.assign(file, {id: this.files.length + 1})
      this.addAudience(file)
    },
    removeFile (id) {
      this.files = this.files.filter(file => file.id !== id)
    },
    nextPage () {
      this.$emit('next')
    },
    previousPage () {
      this.$emit('previous')
    },
    setTargeting (targeting, status) {
      this.next = status
      this.$emit('setTargeting', targeting)
    },
    ...mapActions([
      'addAudience',
      'removeAudience'
    ])
  }
}
</script>
<style>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .2s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
